import NextLink from "next/link"
import NextRouter from "next/router"

export const Link = NextLink
export const Router = NextRouter
